export let MjmlAttribute = /*#__PURE__*/function (MjmlAttribute) {
  MjmlAttribute["NAME"] = "name";
  MjmlAttribute["COLOR"] = "color";
  MjmlAttribute["BACKGROUND_COLOR"] = "background-color";
  MjmlAttribute["CONTAINER_BACKGROUND_COLOR"] = "container-background-color";
  MjmlAttribute["FONT_FAMILY"] = "font-family";
  MjmlAttribute["FONT_SIZE"] = "font-size";
  MjmlAttribute["FONT_WEIGHT"] = "font-weight";
  MjmlAttribute["FONT_STYLE"] = "font-style";
  MjmlAttribute["TEXT_DECORATION"] = "text-decoration";
  MjmlAttribute["LINE_HEIGHT"] = "line-height";
  MjmlAttribute["LETTER_SPACING"] = "letter-spacing";
  MjmlAttribute["BORDER"] = "border";
  MjmlAttribute["BORDER_TOP"] = "border-top";
  MjmlAttribute["BORDER_RIGHT"] = "border-right";
  MjmlAttribute["BORDER_BOTTOM"] = "border-bottom";
  MjmlAttribute["BORDER_LEFT"] = "border-left";
  MjmlAttribute["BORDER_RADIUS"] = "border-radius";
  MjmlAttribute["BORDER_WIDTH"] = "border-width";
  MjmlAttribute["BORDER_COLOR"] = "border-color";
  MjmlAttribute["BORDER_STYLE"] = "border-style";
  MjmlAttribute["HREF"] = "href";
  MjmlAttribute["TARGET"] = "target";
  MjmlAttribute["LINK_TYPE"] = "data-em-link-type";
  MjmlAttribute["LINK_FILENAME"] = "data-em-link-filename";
  MjmlAttribute["LINK_SERVICE_ID"] = "data-em-link-service-id";
  MjmlAttribute["ALIGN"] = "align";
  MjmlAttribute["SRC"] = "src";
  MjmlAttribute["ALT"] = "alt";
  MjmlAttribute["VIDEO_URL"] = "video-url";
  MjmlAttribute["CUSTOM_HTML"] = "custom-html";
  MjmlAttribute["WIDTH"] = "width";
  MjmlAttribute["PADDING"] = "padding";
  MjmlAttribute["PADDING_TOP"] = "padding-top";
  MjmlAttribute["PADDING_RIGHT"] = "padding-right";
  MjmlAttribute["PADDING_BOTTOM"] = "padding-bottom";
  MjmlAttribute["PADDING_LEFT"] = "padding-left";
  return MjmlAttribute;
}({});
export const BORDER_LONGHANDS = [MjmlAttribute.BORDER_TOP, MjmlAttribute.BORDER_RIGHT, MjmlAttribute.BORDER_BOTTOM, MjmlAttribute.BORDER_LEFT];
export const PADDING_LONGHANDS = [MjmlAttribute.PADDING_TOP, MjmlAttribute.PADDING_RIGHT, MjmlAttribute.PADDING_BOTTOM, MjmlAttribute.PADDING_LEFT];
export const BORDER_STYLES = ['none', 'hidden', 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'];
//# sourceMappingURL=attributes.js.map